import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function OutputDetails({ details }) {
    if (details.length >= 1) {
        return details.map((detail, idx) => <p key={idx}>{detail.note} : {formatDateMonthYear(detail.date)}</p>)
    } else {
        return null
    }
}

export function OutputSubstanceDetails({ details }) {
    if (details.length >= 1) {
        return (
            <table>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Substance used</th>
                        <th>Level of consumption</th>
                    </tr>
                </thead>
                <tbody>
                    {details.map((detail, idx) =>
                        <tr key={idx}>
                            <td>{formatDateMonthYear(detail.date)}</td>
                            <td>{detail.substance}</td>
                            <td>{detail.consumption}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        )
    } else {
        return null
    }
}